import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { IntegrityMonitorEventsController } from '../controller/IntegrityMonitorEventsController';
import { IntegrityMonitorRulesGridController } from '../../../integrityMonitorRules/integrityMonitorRulesGrid/controller/IntegrityMonitorRulesGridController';

export class IntegrityMonitorEventsWebComponent extends BaseWebComponentElement {
  public controller: IntegrityMonitorRulesGridController;
  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: IntegrityMonitorEventsController,
    });
  }

  public refreshGrid(): void {
    this.controller.view.dom.$gridView.controller.handleGridItemsLoad(true);
  }
}
